import React, { useState, useEffect } from 'react';
import {
  Box,
  CssBaseline,
  Container,
  Card,
  CardContent,
  Button,
  Grid,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  TextField,
  InputAdornment,
  IconButton
} from "@mui/material";
import AuthApi4 from "../services/authApi";
import Navbar from "../sidebar/SideNavbar";
import setTopBox from "../images/stb_new.jpeg";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import ClearIcon from '@mui/icons-material/Clear';

export default function BulkCancel() {
  const [stbData, setStbData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkedItems, setCheckedItems] = useState({});
  const [selectedSTBs, setSelectedSTBs] = useState([]);
  const [selectAllToggle, setSelectAllToggle] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchSTBs();
  }, []);

  const handleRefresh = async () => {
    setLoading(true);

    let payload = {
      PHONE: localStorage.getItem("phoneNumber"),
      operator_id: parseInt(localStorage.getItem("ownerId")),
      FLAG: "A"
    };

    try {
      const response = await fetch(
        "https://api.mobiezy.in/php/NXTV2/hotel_import.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      let json = await response.json();
      console.log("REFRESH API RESPONSE", json);

      localStorage.setItem("BULK_IMPORTED", "Y");
      await fetchSTBs();

      Swal.fire({
        icon: "success",
        title: "Data Refreshed",
        timer: 1200,
        showConfirmButton: false,
      });
    } catch (error) {
      console.log("REFRESH ERROR", error);

      Swal.fire({
        icon: "error",
        title: "Refresh Failed",
      });

      setLoading(false);
    }
  };

  const fetchSTBs = async () => {
    setLoading(true);
    let data = {
      records: [
        {
          operator_id: parseInt(localStorage.getItem("ownerId")),
          CUST_ID: localStorage.getItem("payment_cust_num"),
          type: "bulkInActive"
        },
      ],
    };
    try {
      const response = await AuthApi4.stbinfo(data);
      setStbData(response.data.stbdetails);
      const initialCheckedState = {};
      response.data.stbdetails.forEach((_, index) => {
        initialCheckedState[index] = false;
      });
      setCheckedItems(initialCheckedState);
    } catch (e) {
      console.log("STB INFO Error", e);
    }
    setLoading(false);
  };

  const handleCheckboxChange = (index, stbId) => {
    setCheckedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));

    setSelectedSTBs(prev => {
      if (prev.includes(stbId)) return prev.filter(id => id !== stbId);
      return [...prev, stbId];
    });
  };

  const toggleSelectAll = () => {
    if (!selectAllToggle) {
      const allSTBs = stbData.map(item => item.STB_ID);
      const newChecked = {};
      stbData.forEach((_, i) => newChecked[i] = true);
      setCheckedItems(newChecked);
      setSelectedSTBs(allSTBs);
    } else {
      const newChecked = {};
      stbData.forEach((_, i) => newChecked[i] = false);
      setCheckedItems(newChecked);
      setSelectedSTBs([]);
    }
    setSelectAllToggle(!selectAllToggle);
  };

  const handleSubmit = () => {
    const stbIdsArray = selectedSTBs.map(item => ({ stb_id: item }));
    navigate('/bulkModify', { state: { stbId: stbIdsArray } });
  };

  const checkedCount = Object.values(checkedItems).filter(Boolean).length;
  const totalSelectedAmount = stbData
    .filter(item => selectedSTBs.includes(item.STB_ID))
    .reduce((sum, stb) => sum + parseFloat(stb.sub_total), 0);

  // ---- Filter STBs based on search ----
  const filteredStbData = stbData.filter((item) => {
  const search = searchTerm.toLowerCase();

  // Convert every item value to string and combine
  const combinedValues = Object.values(item)
    .join(" ")
    .toLowerCase();

  return combinedValues.includes(search);
});


  return (
    <div style={{ display: "flex", background: "#F5F5F5" }}>
      <CssBaseline />
      <Navbar />
      <main style={{ flexGrow: 1 }}>
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            margin: 'auto',
            minHeight: '100vh',
            padding: 10
          }}
        >
          <Box display="flex" alignItems="center" flexWrap="wrap" mb={2}>
            <h3 style={{ marginRight: '20px' }}>Inactive Boxes Bulk Renew</h3>

            <Button
              variant="contained"
              color={selectAllToggle ? "warning" : "primary"}
              onClick={toggleSelectAll}
            >
              {selectAllToggle ? "Unselect All" : "Select All"}
            </Button>

            <Button
              variant="contained"
              sx={{
                marginLeft: "15px",
                backgroundColor: "#ff8c00",
                '&:hover': { backgroundColor: "#ffad42" }
              }}
              onClick={handleRefresh}
            >
              Refresh
            </Button>

            {/* ---- Search Bar ---- */}
            <TextField
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search STB / VC / Customer ID..."
              size="small"
              sx={{ marginLeft: "15px", width: "350px" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchTerm && (
                      <IconButton onClick={() => setSearchTerm('')} size="small">
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
            />

            <div
              style={{
                marginLeft: "auto",
                textAlign: "right",
                paddingRight: "10px",
                lineHeight: "1.9",
              }}
            >
              <h5 style={{ margin: 0 }}>Selected Boxes: {checkedCount}</h5>
              <h5 style={{ margin: 0 }}>Total Pack Amount: ₹ {totalSelectedAmount.toFixed(2)}</h5>
            </div>
          </Box>

          <Grid container spacing={1}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '20px' }}>
                <CircularProgress />
              </Box>
            ) : filteredStbData.length > 0 ? (
              filteredStbData.map((item, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Card sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: checkedItems[index] ? '#d3ffd3' : '#f5f5f5',
                    borderRadius: 4,
                    boxShadow: 6,
                    transition: 'background-color 0.3s ease'
                  }}>
                    <Grid container style={{ width: '100%', position: 'relative' }}>
                      <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', padding: '8px 10px 0 10px', margin: '0' }}>
                        <p style={{ fontSize: '1rem', margin: '0' }}>
                          <strong>ID: </strong>
                          <strong style={{ color: '#ff8c00' }}>{item.CUSTOMER_ID}</strong>
                        </p>
                      </Grid>
                      <div style={{ position: 'absolute', right: '2px' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checkedItems[index] || false}
                              onChange={() => handleCheckboxChange(index, item.STB_ID)}
                            />
                          }
                        />
                      </div>
                    </Grid>

                    <Grid container style={{ width: '100%', minHeight: '160px' }}>
                      <Grid item xs={5} style={{ display: 'flex', justifyContent: 'flex-start', padding: '6px', margin: '0' }}>
                        <img
                          src={setTopBox}
                          alt="Set-Top Box"
                          style={{
                            width: '85%',
                            height: 'auto',
                            maxHeight: '100px',
                            objectFit: 'contain',
                          }}
                        />
                      </Grid>
                      <Grid item xs={7} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '0', margin: '0' }}>
                        <CardContent style={{ flexGrow: 1, padding: '0', marginLeft: '0' }}>
                          <p style={{ fontSize: '0.65rem' }}>STB Number: <strong>{item.STB_NUMBER}</strong></p>
                          <p style={{ fontSize: '0.65rem' }}>VC Number: <strong>{item.VC_NUMBER}</strong></p>
                          <p style={{ fontSize: '0.65rem' }}>Pack Amount: <strong>{item.sub_total}</strong></p>
                          <p style={{ fontSize: '0.65rem' }}>Status: <strong style={{ color: item.STATUS === "Active" ? "green" : "red" }}>{item.STATUS}</strong></p>
                          <p style={{ fontSize: '0.65rem' }}>Expiry Date: <strong>{moment(item.PRE_END_DATE).utc().format('DD-MM-YYYY')}</strong></p>
                        </CardContent>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              ))
            ) : <p>No data available</p>}
          </Grid>

          <Grid container spacing={1} style={{ marginTop: '20px' }}>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div
                style={{
                  position: "fixed",
                  bottom: "90px",
                  right: "90px",
                  zIndex: 1000,
                }}
              >
                <button
                  onClick={handleSubmit}
                  disabled={selectedSTBs.length === 0}
                  style={{
                    backgroundColor: selectedSTBs.length === 0 ? "#FFD8A8" : "orange",
                    color: "white",
                    border: "none",
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    fontWeight: "bold",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    opacity: selectedSTBs.length === 0 ? 0.6 : 1,
                    transition: "0.3s ease",
                  }}
                >
                  NEXT
                </button>
              </div>
            </Grid>
          </Grid>
        </Container>
      </main>
    </div>
  );
}
